document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper !== 'undefined') {
    new Swiper('.logo-carousel', {
      loop: true,
      centeredSlides: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      slidesPerView: 2,
      spaceBetween: 30,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: 3
        },
        1024: {
          slidesPerView: 6
        }
      }
    });
  }
});
